import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";
import { ReplaceMediaButton } from "../ReplaceMediaButton";
import { UploadMediaButton } from "../UploadMediaButton";
import type { InlineAttachment } from "./useMediaPicker";
import { useMediaPicker } from "./useMediaPicker";

export interface MediaPickerProps {
  file: InlineAttachment;
  onClickRemove: () => void;
  onUploadComplete: (file: InlineAttachment) => void;
  onUploadStarted: () => void;
}

export const MediaPicker = ({
  file,
  onUploadStarted,
  onUploadComplete,
  onClickRemove,
}: MediaPickerProps) => {
  const {
    progress,
    isUploading,
    getRootProps,
    getInputProps,
    onSelectFile,
    fileSize,
  } = useMediaPicker({
    onUploadStarted,
    onUploadComplete,
  });

  return (
    <>
      <input {...getInputProps()} />
      <Form.Item
        label={t("builder_ui.prop_type.attachment_upload.add_file")}
        hideDescription
        hideBorder
        className="!p-0"
      >
        {file?.url ? (
          <ReplaceMediaButton
            onClickReplace={onSelectFile}
            onClickRemove={onClickRemove}
            filename={file.filename}
            byte_size={file.byte_size === 0 ? fileSize : file.byte_size}
          />
        ) : (
          <UploadMediaButton
            progress={progress}
            isUploading={isUploading}
            onSelectFile={onSelectFile}
            getRootProps={getRootProps}
            ariaLabel={t("builder_ui.prop_type.attachment_upload.add_file")}
            uploadingText={t(
              "builder_ui.prop_type.attachment_upload.uploading_file",
            )}
          />
        )}
      </Form.Item>
    </>
  );
};
